// Material Dashboard 2 React - v2.2.0

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import userTableData from "layouts/daftar-pelanggan/data/userTableData";
import { useState, useMemo } from "react";

function Users() {
  const { columns, rows, modalEdit, modalDetail, modalDelete } = userTableData();

  const [searchTerm, setSearchTerm] = useState("");

  const getText = (value) => {
    if (!value) return "";
    if (typeof value === "string") return value;
    if (typeof value === "number") return String(value);

    if (value.props && value.props.children) {
      if (typeof value.props.children === "string") return value.props.children;
      if (Array.isArray(value.props.children))
        return value.props.children.map((child) => getText(child)).join(" ");
      return getText(value.props.children);
    }

    return "";
  };

  const filteredRows = useMemo(() => {
    const keyword = searchTerm.toLowerCase();

    return rows.filter((row) => {
      const username = getText(row.username).toLowerCase();
      const businessName = getText(row.businessName).toLowerCase();
      const name = getText(row.name).toLowerCase();
      const address = getText(row.address).toLowerCase();
      const noHp = getText(row.noHp).toLowerCase();

      return (
        username.includes(keyword) ||
        businessName.includes(keyword) ||
        noHp.includes(keyword) ||
        name.includes(keyword) ||
        address.includes(keyword)
      );
    });
  }, [rows, searchTerm]); // Hanya dihitung ulang jika rows atau searchTerm berubah

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              {/* Header dan Search Bar */}
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Daftar Pelanggan
                </MDTypography>
              </MDBox>

              <MDInput
                type="text"
                label="Cari pelanggan..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                sx={{
                  borderRadius: "8px",
                  marginInline: "3%",
                  marginTop: "3%",
                }}
              />

              {/* Data Table */}
              <MDBox pt={3} px={2}>
                <DataTable
                  table={{ columns, rows: filteredRows }}
                  isSorted
                  entriesPerPage
                  showTotalEntries
                  noEndBorder
                />

                {/* Modal Section */}
                {modalEdit}
                {modalDetail}
                {modalDelete}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Users;
